/**
 * Nombre e iniciales del usuario de la sesión.
 *
 * El CMDB no tiene tabla de usuarios: los datos vienen del IdP y, según por
 * dónde haya pasado el token, el nombre llega en campos distintos. Esta es la
 * única traducción de esos campos a algo presentable, para que la cabecera y
 * «Mi perfil» no enseñen cosas diferentes.
 */

export function getUserDisplayName(user) {
  return (
    user?.full_name ||
    user?.name ||
    user?.display_name ||
    (user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : '') ||
    user?.first_name ||
    (user?.email ? user.email.split('@')[0] : '') ||
    'Usuario'
  );
}

export function getUserInitials(user) {
  const name = getUserDisplayName(user);
  if (!name) return 'U';
  const parts = name.split(' ').filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
}
